import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Card } from "../ui/card";
import { cn } from "@/lib/utils";

interface SearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  isUpside?: boolean;
}

export function SearchBar({
  value,
  onChange,
  placeholder,
  className,
  isUpside = false,
}: SearchBarProps) {
  const { t } = useTranslation();

  return (
    <Card
      className={cn({
        "md:py-2.5 md:px-4 flex items-center gap-4 bg-background rounded-xl shadow-md":
          true,
        [className || ""]: !!className,
        "w-[80%] ml-3": isUpside,
        "w-[94%] lg:w-full mx-auto": !isUpside,
      })}
    >
      <div className="relative flex-1">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          <Search className="w-5 h-5" />
        </span>
        <Input
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder || t("community.search")}
          className="pl-10 pr-4 py-2 md:text-xl font-bold bg-transparent border-none focus:ring-0 outline-none shadow-none text-gray-500"
          style={{
            boxShadow: "none",
            background: "transparent",
          }}
        />
      </div>
    </Card>
  );
}
